export const BOOKING = 'BOOKING';
export const OPTION = 'OPTION';
